/* PÖUSE — scroll motion.
   Tags each section's content, then lets CSS play it in as a 150ms cascade
   when the section reaches the viewport. Modelled on pal&leo's AOS setup. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Sections that animate themselves, or must never be hidden. */
  var SKIP = '.pouse-header, .pouse-ticker, .pouse-strip, .pouse-icons';

  /* Everything that animates, in rough reading order. */
  var ITEMS = [
    '.p-eyebrow', '.p-takea', '.p-word', '.p-kicker', '.p-pre', '.o-pre',
    'h1', 'h2', 'h3', '.p-h', '.o-h', '.s-h', '.m-h',
    '.p-sub', '.p-blurb', '.p-product',
    '.f-chapter', '.f-quote', '.f-note', '.p-punch', '.p-sign',
    '.p-card', '.r-card', '.p-band', '.m-card', '.p-col', '.p-tile',
    '.p-shot', '.r-shot', '.b-shot', '.m-shot', '.f-photo', '.p-right',
    '.p-pairs li', '.p-more', '.p-cta', '.p-form'
  ].join(',');

  /* Photos settle out of a slight push-in. */
  var IMAGEY = '.p-shot, .r-shot, .b-shot, .m-shot, .f-photo, .p-right, .p-word';

  /* Cards and pills grow into place. */
  var ZOOMY = '.p-card, .r-card, .m-card, .p-col, .p-band, .p-tile, .p-pairs li';

  var sections = [].slice.call(document.querySelectorAll('.pouse, .pouse-foot'))
    .filter(function (s) { return !s.matches(SKIP) && !s.closest(SKIP); });

  if (!sections.length) return;

  sections.forEach(function (section) {
    var picked = [];

    [].slice.call(section.querySelectorAll(ITEMS)).forEach(function (el) {
      /* One animation per thing: skip anything inside something already picked. */
      for (var i = 0; i < picked.length; i++) {
        if (picked[i].contains(el)) return;
      }
      if (el.getBoundingClientRect().height > window.innerHeight * 0.95) return;
      picked.push(el);
    });

    /* 12 items at 150ms lands the last one on 1650ms — the reference's longest chain. */
    picked.slice(0, 12).forEach(function (el, i) {
      el.classList.add('rv');
      if (el.matches(IMAGEY)) el.classList.add('rv-img');
      else if (el.matches(ZOOMY)) el.classList.add('rv-zoom');
      else el.classList.add('rv-fade');
      el.style.setProperty('--rv-i', i);
    });

    if (picked.length) section.dataset.rv = '1';
  });

  document.documentElement.classList.add('rv-on');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var section = entry.target;
      section.classList.add('is-in');
      io.unobserve(section);

      var items = section.querySelectorAll('.rv');
      var last = items[items.length - 1];
      if (!last) return;
      var done = function () {
        [].forEach.call(items, function (el) { el.classList.add('rv-done'); });
      };
      last.addEventListener('animationend', done, { once: true });
      setTimeout(done, 4000);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

  sections.forEach(function (s) { if (s.dataset.rv) io.observe(s); });

  /* Shopify's editor re-renders sections. Show new markup immediately —
     never reload, that would trap the editor in a loop. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = (e.detail && e.detail.sectionId)
      ? document.querySelector('[id*="' + e.detail.sectionId + '"]')
      : null;
    var scope = root || document;
    [].forEach.call(scope.querySelectorAll('.pouse, .pouse-foot'), function (s) {
      s.classList.add('is-in');
    });
    [].forEach.call(scope.querySelectorAll('.rv'), function (el) {
      el.classList.add('rv-done');
    });
  });
})();
